import {Component, OnInit, ViewChild} from '@angular/core';
import {ApiService} from '../../api.service';
import {AvailableTagsComponent} from '../../tags/available-tags/available-tags.component';
import {PaginationComponent} from '../../shared/pagination/pagination.component';
import {PaginationService} from '../../shared/pagination.service';
import {TaggedBaseComponent} from '../../tags/tagged-base/tagged-base.component';

@Component({
    selector: 'app-list-links',
    templateUrl: './list-links.component.html',
    styleUrls: ['./list-links.component.css']
})
export class ListLinksComponent extends TaggedBaseComponent implements OnInit {
    public links: any;
    public loaded = false;
    protected currentPage = 1;
    protected linksPerPage: number;
    public linksToDisplay;
    public linksOnThisPage;
    public itemcount;

    constructor(private apiService: ApiService, protected paginationService: PaginationService) {
        super('links');
    }

    setLinksOnThisPage() {
        if (typeof this.linksToDisplay === 'undefined') {
            return;
        }
        this.linksOnThisPage = this.linksToDisplay.sort((a, b) => {
            return a.added < b.added ? 1 : -1;
        }).slice((this.currentPage - 1) * this.linksPerPage, this.currentPage * this.linksPerPage);
    }

    ngOnInit() {
        this.linksPerPage = this.paginationService.getItemsPerPage();
        this.getLinks();
        this.paginationService.getSubject().subscribe(
            (val) => {
                this.currentPage = val.currentPage;
                this.linksPerPage = val.itemsPerPage;
                this.setLinksOnThisPage();
            },
            (err) => {
                console.log('error in list links paginationService subject observer', err);
            }
        );
    }

    getLinks() {
        this.apiService.getAll('links').subscribe(
            (value) => {
                this.loaded = true;
                this.links = value;
                this.links.map((val) => {
                    val.added = new Date(val.added);
                });
                this.links.sort((a, b) => {
                    return a.added < b.added ? 1 : -1;
                });
                this.setLinksToDisplay();
                this.paginationService.setCurrentPage(1);
                this.setLinksOnThisPage();
            }
        );
    }

    setLinksToDisplay() {
        if (this.selectedTags.length === 0) {
            this.linksToDisplay = this.links;
            this.setLinksOnThisPage();
            this.itemcount = this.linksToDisplay.length;
            this.paginationService.setItemCount(this.itemcount);
            return;
        }
        this.linksToDisplay = this.filtered;
        this.itemcount = this.linksToDisplay.length;
        this.paginationService.setItemCount(this.itemcount);
        this.setLinksOnThisPage();
    }

    deleteLink(id) {
        const confirmed = window.confirm('Are you sure?');
        if (confirmed) {
            this.apiService
                .deleteByID('links', id)
                .toPromise()
                .then(
                    () => {
                        this.getLinks();
                    },
                    () => {
                        alert('deletion failed');
                    }
                );
        }
    }

    addTag(tag) {
        super.addTag(tag);
        this.paginationService.setCurrentPage(1);
        this.setLinksToDisplay();
    }

    removeTag(tag) {
        super.removeTag(tag);
        this.paginationService.setCurrentPage(1);
        this.setLinksToDisplay();
    }

    setTagSelection(selectedTags) {
        super.setTagSelection(selectedTags);
        this.paginationService.setCurrentPage(1);
        this.setLinksToDisplay();
    }

    exportForFirefox() {
        const element = document.createElement('a');

        let bookmarkList = this.links.reduce((bookmarks, link) => {
            console.log('link:', link, 'bookmarks:', bookmarks);
            const date = new Date(link.added);
            const time = date.getTime();
            bookmarks += '<DT>' +
                '<A HREF="' + link.url +
                '" ADD_DATE="' + time +
                '" LAST_MODIFIED="' + time +
                '" ICON_URI=""' +
                ' ICON="" ' +
                'TAGS="' + link.tags.join(',') +
                '">' + link.title + '</A>' +
                '</DT>';
            return bookmarks;
        });
        const now = Date.now();
        bookmarkList = '<DL>' +
            '    <DT><H3 ADD_DATE="' + now + '" LAST_MODIFIED="' + now + '">ngCentrl bookmarks</H3></DT>' +
            '    <DL>' + bookmarkList + '</DL>' +
            '</DL>';

        element.setAttribute('href', 'data:text/html;charset=utf-8,' + encodeURIComponent(bookmarkList));
        element.setAttribute('download', 'ngBookmarks.html');

        element.style.display = 'none';
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
    }

    exportForFirefoxJSON() {
        const element = document.createElement('a');
        const linksCopy = JSON.parse(JSON.stringify(this.links));
        console.log(linksCopy);
        const links = linksCopy.map((link, index) => {
            link.tags = link.tags.join(',');
            link.guid = link._id;
            const time = new Date(link.added);
            link.timeModified = link.dateAdded = time.getTime() * 100;
            link.type = 'text/x-moz-place';
            link.typecode = 1;
            link.uri = link.url;
            link.index = index;
            delete link.url;
            delete link.added;
            delete link.userid;
            delete link.__v;
            delete link.image;
            return link;
        });
        const now = Date.now() * 100;
        const linksRoot = {
            guid: 'root________',
            title: 'Imported from ngCentrl',
            index: 0,
            dateAdded: now,
            lastModified: now,
            id: 1,
            typeCode: 2,
            type: 'text/x-moz-place-container',
            root: 'placesRoot',
            children: links
        };
        const text = JSON.stringify(linksRoot);
        element.setAttribute('href', 'data:text/json;charset=utf-8,' + encodeURIComponent(text));
        element.setAttribute('download', 'ngBookmarks.json');

        element.style.display = 'none';
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
    }
}



// WEBPACK FOOTER //
// ./src/app/links/list-links/list-links.component.ts